




























import Vue from 'vue';
import Carousel from '../Carousel.vue';
import ProductDes from '../ProductDes.vue';
import Attribute from './Attribute.vue'; // 属性与规格
import StandardCode from './StandardCode.vue'; // 标准编码
import Certification from './Certification.vue'; // 认证与评级
import TechnicalDoc from './TechnicalDoc.vue'; // 技术文档
import RelatedProduct from './RelatedProduct.vue'; // 相关产品

export default Vue.extend({
    components: {
        Carousel,
        ProductDes,
        Attribute,
        Certification,
        StandardCode,
        TechnicalDoc,
        RelatedProduct,
    },
    props: ['toolsData', 'information', 'carouselData', 'productDes', 'attribute', 'certification', 'standardCode', 'techDocs', 'relatedProduct'],
    data() {
        return {
            activeId: 1,
        };
    },
    methods: {
        blockChainToggle(val) {
            this.$emit('blockChainToggle', val);
        },
        back() {
            this.$emit('closeMobileTool');
        },
        change(item) {
            const arr = [5, 6, 7];
            if (arr.includes(item.id)) this.$emit('mobileTool', item);
            this.activeId = item.id;
        },
    },
});

